import React, { useEffect, useContext, useState } from 'react'
import { AuthenticationContext } from '../Auth/authentication.context'
import { useBranding } from '../contexts/BrandingContext'
import { Outlet, Navigate } from 'react-router-dom'

const Module = () => {
  const { module, user, setModule } = useContext(AuthenticationContext)
  const { isGroupMode } = useBranding()
  const [isModuleLoaded, setIsModuleLoaded] = useState(false)

  useEffect(() => {
    if (isGroupMode && user) {
      setModule('Origins Management')
      localStorage.setItem('module', 'Origins Management')
    }
  }, [isGroupMode, user, setModule])

  useEffect(() => {
    // Wait for user to be loaded
    if (user) {
      const moduleFromLocalStorage = localStorage.getItem('module')

      if (isGroupMode) {
        setIsModuleLoaded(true)
      }
      // If module is already set in context, we're good
      else if (
        module &&
        (module === 'Origins Direct' || module === 'Origins Direct Instant')
      ) {
        setIsModuleLoaded(true)
      }
      // If module is not set in context but exists in localStorage, wait a bit more
      else if (
        moduleFromLocalStorage &&
        (moduleFromLocalStorage === 'Origins Direct' ||
          moduleFromLocalStorage === 'Origins Direct Instant')
      ) {
        const timer = setTimeout(() => {
          setIsModuleLoaded(true)
        }, 200)

        return () => clearTimeout(timer)
      }
      else {
        setIsModuleLoaded(true)
      }
    }
  }, [user, module, isGroupMode])

  if (!isModuleLoaded) {
    return null
  }

  if (isGroupMode) {
    return <Navigate to='/' replace />
  }

  return (
    <>
      {module === 'Origins Direct' || module === 'Origins Direct Instant' ? (
        <Outlet />
      ) : (
        <Navigate to='/' replace />
      )}
    </>
  )
}

export default Module
